export default function getResource (label, vars = []) {
    const resources = {
        estimatedOrderTotal: 'Estimated Total',
        orderSubTotalWithTax: 'Order Subtotal + Estimated Tax',
        oneTimeReplacementFee: 'One-Time Replacement',
        orderTotal: 'Order Total',
        merchandiseSubtotal: 'Merchandise Subtotal',
        pointsUsed: 'Points Used',
        shippingAndHandling: 'Shipping & Handling',
        shippingAndHandlingInfo: 'Shipping & Handling Information',
        discounts: 'Discounts',
        gstOrHst: 'GST/HST',
        estimatedGstOrHst: 'Estimated GST/HST',
        pst: 'PST',
        estimatedPst: 'Estimated PST',
        tax: 'Tax',
        estimatedTax: 'Estimated Tax',
        storeCreditRedeemed: 'Account Credit',
        giftCardRedeemed: 'Gift Card Redeemed',
        eGiftCardRedeemed: 'eGift Card Redeemed',
        creditCardPayment: 'Credit Card Payment',
        payPalPayment: 'PayPal Payment',
        viewOrCancel: 'To view or cancel your order, go to',
        orderDetails: 'order details',
        pickup: 'Pickup',
        free: 'FREE',
        autoReplenishSavings: 'Auto-Replenish Savings',
        sduBIPointsText: 'You will earn Beauty Insider points once you begin payment on your subscription.'
    };

    return resources[label];
}
